import React from 'react';
import { getValidVideoId, getVideoTypeFromUrl } from '../utils';
import { VimeoVideo } from './vimeo/VimeoVideo';
import { YoutubeVideo } from './youtube/YoutubeVideo';
import { PlaceholderVideo } from './PlaceholderVideo';

interface VideoDataHandlerProps {
  videoUrl: string | undefined;
  shouldShowPreview: boolean;
  readonly: boolean;
}

export const VideoDataHandler = ({
  videoUrl,
  shouldShowPreview,
  readonly,
}: VideoDataHandlerProps) => {
  if (!videoUrl) return <PlaceholderVideo />;

  const videoType = getVideoTypeFromUrl(videoUrl);
  const videoId = getValidVideoId(videoUrl);

  if (videoType === 'youtube') {
    return (
      <YoutubeVideo
        src={videoUrl}
        shouldShowPreview={shouldShowPreview}
        readonly={readonly}
      />
    );
  }

  if (videoType === 'vimeo' && typeof videoId === 'number') {
    return (
      <VimeoVideo
        videoUrl={videoUrl}
        videoId={videoId}
        shouldShowOverlay={!shouldShowPreview}
        readonly={readonly}
      />
    );
  }

  return <PlaceholderVideo />;
};
